import { Grid2 as Grid, Typography } from "@mui/material";
import { formatDateTimeDutch } from "../utils/dateFormat";

interface MutationsSectionProps {
  /** The user or system that created the entity */
  createdBy?: string | null;
  /** The creation date/time */
  createdDate?: Date | string | null;
  /** The user or system that last modified the entity */
  lastModifiedBy?: string | null;
  /** The last modification date/time */
  lastModifiedDate?: Date | string | null;
  /** Grid size configuration (defaults to { xs: 12 }) */
  gridSize?: { xs?: number; sm?: number; md?: number; lg?: number };
}

/**
 * Reusable component to display audit trail information (mutations)
 * Shows who created and last modified an entity with Dutch date formatting
 * 
 * @example
 * <MutationsSection
 *   createdBy="Floricode"
 *   createdDate={product.created}
 *   lastModifiedBy="Floricode Sync Service"
 *   lastModifiedDate={product.lastModified}
 * />
 */
export const MutationsSection: React.FC<MutationsSectionProps> = ({
  createdBy,
  createdDate,
  lastModifiedBy,
  lastModifiedDate,
  gridSize = { xs: 12 },
}) => {
  return (
    <Grid size={gridSize}>
      <Typography
        variant="h4"
        gutterBottom
        sx={{
          mb: 1.5,
          fontSize: "1rem",
          fontWeight: 600,
        }}
      >
        Mutaties
      </Typography>
      <Typography variant="body2" sx={{ fontSize: "0.8125rem", mb: 0.5, opacity: 0.75 }}>
        Aangemaakt door {createdBy || "-"} op{" "}
        {formatDateTimeDutch(createdDate) || "-"}
      </Typography>
      <Typography variant="body2" sx={{ fontSize: "0.8125rem", opacity: 0.75 }}>
        Laatst gewijzigd door {lastModifiedBy || "-"} op{" "}
        {formatDateTimeDutch(lastModifiedDate) || "-"}
      </Typography>
    </Grid>
  );
};
